import cx from 'classnames';
import type { VoidFunctionComponent } from 'react';

import Loader from '../../generic/Loader';
import { useExecutivePreviewURL } from '../hooks/useExecutivePreviewURL';
import { useLoadPreview } from '../preview/hooks';

import previewStyles from '../preview/Preview.module.less';

export const ExecutiveVulnerabilityPreview: VoidFunctionComponent = () => {
  const previewURL = useExecutivePreviewURL();
  const { cacheBustedURL, debouncedPreviewURL, isLoading, isPending, onIframeLoad } = useLoadPreview(previewURL);

  return (
    <div className={previewStyles.preview}>
      <header className={previewStyles.header}>
        <span className={previewStyles.headerTitle}>
          Preview
        </span>
      </header>
      {isLoading && (
        <div className={previewStyles.loading}>
          <Loader />
          <span className={previewStyles.loadingText}>
            Your sample report is being generated...
          </span>
        </div>
      )}
      {/* oxlint-disable-next-line react/iframe-missing-sandbox -- This preview is always a PDF, and Chrome's PDF viewer can't render in a sandboxed iframe. See preview/index.tsx. */}
      <iframe
        key={cacheBustedURL}
        src={debouncedPreviewURL}
        title="executive-vulnerability-preview"
        onLoad={onIframeLoad}
        className={cx(previewStyles.iframe, (isLoading || isPending) && previewStyles.iframeLoading)}
      />
    </div>
  );
};
